import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { TableContainer } from '@mui/material';
import {
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Table,
} from '@mui/material';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import { Snackbar } from '@mui/material';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close'; // เพิ่ม CloseIcon
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import theme from '../../theme';

function NotiAlertConfirmSendmail({
  selectedRows,
  setOpenDialogSendmail,
  openDialogSendmail,
  onButtonClickSendmail,
  setSelectedOption,
  selectedOption,
  options,
  customerEmail,
  openConfirmSendmail,
  setOpenConfirmSendmail,
  handleCheckPDFmail,
  snackBarLoading,
  setEmailChange,
  emailChange,
  dataCheckMail,
  isLoading,
  loadingMessage,
  t,
}) {
  const handleConfirmEmail = () => {
    setIsEditing(false); // กลับไปที่โหมดดู
    // คุณสามารถเพิ่มการส่งข้อมูลไปยัง backend ตรงนี้ได้หากต้องการ
    console.log('Email Confirmed:', emailChange);
  };

  const [isEditing, setIsEditing] = useState(false); // สถานะสำหรับโหมด "แก้ไข"

  const handleCancelEdit = () => {
    setEmailChange(customerEmail); // ยกเลิกการเปลี่ยนแปลงและกลับไปที่อีเมลเดิม
    setIsEditing(false); // ออกจากโหมดแก้ไข
  };

  const handleChangeEmail = (event) => {
    setEmailChange(event.target.value); // อัปเดตค่าอีเมลใน state
  };

  const handleEditToggle = () => {
    setIsEditing(!isEditing); // สลับสถานะระหว่าง "ดู" และ "แก้ไข"
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleClose = () => {
    setOpenDialogSendmail(false);
    setOpenConfirmSendmail(false);
  };

  const handleBack = () => {
    setOpenDialogSendmail(true);
    setOpenConfirmSendmail(false);
  };

  const allFilesAttached = dataCheckMail.pdfList?.every((item) => item.hasFile);

  const customCellHeader = {
    fontSize: '12px',
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    padding: '5px',
  };

  const customCellData = {
    fontSize: '12px',
    padding: '5px',
  };

  return (
    <>
      {/* --- Dialog ที่ 1: Send Email --- */}
      <Dialog
        onClose={handleClose}
        fullWidth
        maxWidth="md" // 1. กำหนด maxWidth ที่เหมาะสม (เช่น 'md', 'sm', 'lg')
        aria-labelledby="customized-dialog-title"
        open={openDialogSendmail}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '15px',
            // 2. ลบ width, height, minHeight ที่เป็นค่าตายตัวออก
            // ให้ fullWidth และ maxWidth จัดการความกว้างแทน
            // และให้ความสูงเป็นไปตามเนื้อหา
          },
        }}
      >
        {/* Header */}
        <DialogActions
          sx={{
            backgroundColor: '#4caf50',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div
            style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: 'white',
                mb: 0, // ปรับ margin-bottom ที่มาจาก gutterBottom
              }}
            >
              {t('app.sendEmail')}
            </Typography>
          </div>

          <IconButton aria-label="close" onClick={handleClose}>
            <CancelOutlinedIcon />
          </IconButton>
        </DialogActions>

        {/* Content */}
        {/* 3. ใช้ 'dividers' เพื่อเพิ่มเส้นคั่นระหว่าง Content กับ Actions */}
        <DialogContent dividers>
          <div className="">
            {/* 4. ทำให้ FormControl เต็มความกว้างใน Dialog */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="demo-simple-select-label">
                {t('app.selectDocument')}
              </InputLabel>
              <Select
                value={selectedOption}
                onChange={handleSelectChange}
                label="เลือกเอกสาร"
              >
                {options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {/* <div> (Empty div - removed) </div> */}
          <div>
            {/* 5. ลบ DialogContent ที่ซ้อนกันอยู่ออก */}
            <div className="">
              {/* maxHeight: 230 ตรงนี้ดีอยู่แล้ว ทำให้ตาราง scroll ได้ */}
              <TableContainer sx={{ width: '100%', maxHeight: 230 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={customCellHeader}>
                        {t('app.invoiceNo')}
                      </TableCell>
                      <TableCell align="center" sx={customCellHeader}>
                        {t('navbar.custNo')}
                      </TableCell>
                      <TableCell align="center" sx={customCellHeader}>
                        {t('navbar.custName')}
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {_.size(selectedRows) ? (
                    <TableBody>
                      {selectedRows.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            '&:last-child td, &:last-child th': {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell align="center" sx={customCellData}>
                            {row.invoice_no}
                          </TableCell>
                          <TableCell align="center" sx={customCellData}>
                            {row.customer.customer_code}
                          </TableCell>
                          <TableCell align="center" sx={customCellData}>
                            {row.customer.customer_name}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={10} align="center">
                          <div>ไม่มีข้อมูล</div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </div>
          </div>
        </DialogContent>

        {/* Footer */}
        {/* 6. ย้าย DialogActions (Footer) ออกมานอก DialogContent */}
        <DialogActions
          sx={{
            // 7. ลบ position: 'absolute' และ bottom/left/right ออก
            borderTop: '1px solid #ccc',
            backgroundColor: '#fff',
            padding: '20px',
            justifyContent: 'center', // จัดปุ่มให้อยู่กลาง
          }}
        >
          <div // 8. แก้ไข 'dvi' เป็น 'div'
            style={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div>
              <Button
                variant="contained"
                autoFocus
                onClick={handleClose}
                sx={{
                  color: '#fff',
                  borderRadius: 15,
                  backgroundColor: 'grey',
                }}
              >
                {t('app.cancel')}
              </Button>
            </div>
            <div className="ml-2">
              <Button
                variant="contained"
                autoFocus
                onClick={handleCheckPDFmail}
                sx={{ color: '#fff', borderRadius: 15 }}
              >
                {t('app.verifyDocument')}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>

      {/* --- Dialog ที่ 2: Confirm Send Email --- */}
      <Dialog
        onClose={handleClose}
        fullWidth
        maxWidth="sm" // 9. กำหนด maxWidth ที่เหมาะสม (เช่น 'sm')
        open={openConfirmSendmail}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '16px',
            // 10. ลบ width, maxWidth: 'none' และ minHeight ออก
            height: 'auto', // ความสูงอัตโนมัติตามเนื้อหา
            padding: 2,
          },
        }}
      >
        {/* Header */}
        <DialogActions
          sx={{
            backgroundColor: theme.palette.primary.main,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingY: 1,
            paddingX: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: 'white', textAlign: 'center', flex: 1 }}
          >
            {t('app.confirmSubmission')}
          </Typography>
          <IconButton onClick={handleClose} sx={{ color: 'white' }}>
            <CancelOutlinedIcon />
          </IconButton>
        </DialogActions>

        {/* Content */}
        <DialogContent>
          <div className="text-lg font-medium mt-4 mb-2 text-center text-gray-700">
            {t('app.sendEmailTo')}{' '}
            <span className="text-blue-500">{'Thanaphat.arn@gmail.com'}</span>
          </div>

          <div className="flex items-start text-sm text-gray-600 bg-yellow-50 border-l-4 border-yellow-400 p-3 rounded-md">
            <AnnouncementOutlinedIcon className="text-yellow-500 mt-0.5" />
            <span className="ml-2">{t('app.emailAttachmentWarning')}</span>
          </div>

          {/* Invoice list */}
          {/* ส่วนนี้ใช้ Tailwind และ overflow-x-auto ซึ่งดีอยู่แล้วสำหรับ Responsive */}
          <div className="mt-3 overflow-x-auto">
            <table className="min-w-full text-sm text-left border border-gray-200">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-4 py-2 border-b"> {t('app.sequence')} </th>
                  <th className="px-4 py-2 border-b">
                    {t('app.invoiceNumber')}
                  </th>
                  <th className="px-4 py-2 border-b">
                    {t('app.documentStatus')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataCheckMail.pdfList?.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border-b">{index + 1}</td>
                    <td className="px-4 py-2 border-b">{item.invoiceNo}</td>
                    <td
                      className={`px-4 py-2 border-b font-semibold ${
                        item.hasFile ? 'text-green-600' : 'text-red-500'
                      }`}
                    >
                      {item.hasFile
                        ? t('app.attachment')
                        : t('app.noAttachment')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ paddingX: 3, paddingBottom: 2 }}>
          <Button
            variant="contained"
            onClick={handleBack}
            sx={{
              backgroundColor: '#9e9e9e',
              color: '#fff',
              borderRadius: 15,
              '&:hover': { backgroundColor: '#7e7e7e' },
            }}
          >
            {t('app.back')}
          </Button>
          <Button
            variant="contained"
            onClick={onButtonClickSendmail}
            disabled={!allFilesAttached}
            sx={{
              backgroundColor: '#3FC37C',
              color: '#fff',
              borderRadius: 15,
              '&:hover': {
                backgroundColor: allFilesAttached ? '#36af6f' : '#3FC37C',
              },
              opacity: allFilesAttached ? 1 : 0.6,
              cursor: allFilesAttached ? 'pointer' : 'not-allowed',
            }}
          >
            {t('app.sendEmail')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NotiAlertConfirmSendmail;
